export const TRADEAPI_URL = process.env.REACT_APP_TRADEAPI_URL // API URL
export const LASTPRICE = '/trade/lastprice' // 마지막체결가
export const INDEXPIRCE = '/trade/indexprice' // 인덱스가
export const INFO24H = '/trade/info24h' // 인덱스가
export const ORDERBOOK = '/trade/orderbook' // 오더북

export const CHARTAPI = process.env.REACT_APP_CHART_URL
